import { ConfigurationDeviceOperationResponse } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device-operation/configuration-device-operation.dto'
import { OperationResponse } from '@/modules/configurationModule/detail/local-laboratory-module/sections/services/operation/operation.dto'
import { store } from '@/store/store'

export interface ConfigurationInstrumentationDevicesModalVisibilityFormOperationsState {
    operations: OperationResponse[]
    deviceOperations: ConfigurationDeviceOperationResponse[]
    laboratoryId: number
}
export const initialConfigurationInstrumentationDevicesModalVisibilityFormOperationsState =
    (): ConfigurationInstrumentationDevicesModalVisibilityFormOperationsState => ({
        operations: [],
        deviceOperations: [],
        laboratoryId: store.getters.labId
    })
